<div class="modal__header">
    <div class="modal__header-actions header-actions--mobile">
        <button [attr.aria-label]="'modals.aria.closeDialog' | ibeadmin | async" (click)="INDRA_close()">
			<app-svg svg="icons.svg#general--arrow--left-no_margin" aria-hidden="true" [alt]="'modals.alt.arrowLeftIcon' | ibeadmin | async"></app-svg>
		</button>
    </div>
    <div class="title_wrapper">
        <h2 class="title" id="modal__title">{{ 'modals.text.stopHalfWay' | ibeadmin | async }}</h2>
    </div>
    <div class="modal__header-actions header-actions">
        <button [attr.aria-label]="'modals.aria.closeDialog' | ibeadmin | async" (click)="INDRA_close()">
			<app-svg svg="icons.svg#general--close" aria-hidden="true" [alt]="'modals.alt.closeIcon' | ibeadmin | async"></app-svg>
		</button>
    </div>
</div>

<div class="modal__body select-themes-body sl--scrollable">

    <div>
		<div style="padding: 0px;" class="stopover-illustration__wrapper">
			<img style="width: 100%; height:auto;" src="./assets/images/stopOver_banner.jpg" [alt]="'modals.alt.stopoverBanner' | ibeadmin | async">
		</div>
    </div>

    <div class="stopover-loading" *ngIf="isLoading;else content" role="alert" aria-live="polite">
        <app-loading></app-loading>
        <span>{{ 'modals.label.checkEligibility' | ibeadmin | async }}</span>
    </div>

    <ng-template #content>
        <!-- Hasn't selected the routes -->
        <app-notification class="display--block top-gap" *ngIf="!hasSelectedRoute && !bookAwardFlights" [style]="'note'" [icon]="'icons.svg#general--calendar'" [title]="'modals.label.chooseOriginDestination' | ibeadmin | async">
            <div message>
                <span *ngIf="bookAwardFlights">
					{{ 'modals.text.stopOverUnavailable' | ibeadmin | async }}<br/>
					{{ 'modals.text.ifYouWant' | ibeadmin | async }}
					<a class="link" (click)="INDRA_bookNonAwardTrip()" role="button">{{ 'modals.text.bookNonAward' | ibeadmin | async }}</a>
					{{ 'modals.text.enjoyBenefits' | ibeadmin | async }}
				</span>
                <span>{{ 'modals.text.please' | ibeadmin | async }}
					<a class="link" (click)="INDRA_close()" href="javascript:;" role="button">{{ 'modals.text.chooseAnOriginDestination' | ibeadmin | async }}</a>.
					{{ 'modals.text.stopOversAvailable' | ibeadmin | async }}
				</span>
            </div>
        </app-notification>

        <!-- Route not eligible -->
        <app-notification class="display--block top-gap" *ngIf="hasSelectedRoute && !isEligibleRoute && !bookAwardFlights" [style]="'note'" [icon]="'icons.svg#general--location'" [title]="'modals.text.sorryTripNotEligible' | ibeadmin | async">
            <div message>
                <span>{{ 'modals.text.sorryTripNotEligible' | ibeadmin | async }}<br />
					{{ 'modals.text.ifYouWant' | ibeadmin | async }}
					<a class="link" (click)="INDRA_close()" href="javascript:;" role="button">{{ 'modals.text.bookAnotherTrip' | ibeadmin | async }}</a>
					{{ 'modals.text.benefitsStoppingHalfway' | ibeadmin | async }}
				</span>
            </div>
        </app-notification>

        <app-notification class="display--block top-gap" *ngIf="bookAwardFlights" [style]="'note'" [icon]="'icons.svg#general--location'" [title]="'modals.text.sorryTripNotEligible' | ibeadmin | async">
            <div message>
                <span>
					{{ 'modals.text.stopOverUnavailable' | ibeadmin | async }}<br />
					{{ 'modals.text.ifYouWant' | ibeadmin | async }}
					<a class="link" (click)="INDRA_bookNonAwardTrip()" role="button">{{ 'modals.text.bookNonAward' | ibeadmin | async }}</a>
					{{ 'modals.text.enjoyBenefits' | ibeadmin | async }}
				</span>
            </div>
        </app-notification>

        <div class="top-gap align-right" *ngIf="!hasSelectedRoute || !isEligibleRoute">
            <a class="link link--external" target="_blank" href="https://www.flytap.com//stopover" [attr.aria-label]="'modals.label.moreAboutStopover' | ibeadmin | async">{{ 'modals.label.findAboutMore' | ibeadmin | async }}</a>
        </div>

        <form [formGroup]="form" class="modal__form no-padding" *ngIf="hasSelectedRoute && isEligibleRoute && !bookAwardFlights">

            <ng-container formArrayName="searchroute" *ngIf="!INDRA_disabled()">

                <label class="label">{{ 'modals.label.whenDoYouWantToTravel' | ibeadmin | async }}</label>

                <div class="form-field--row grid no-padding" *ngFor="let item of searchRoutes; let index = index" [formGroupName]="index">
                    <div class="form-field no-margin-adjustment col-6 col-tp-6 col-p-12">
                        <app-large-input-datepicker *ngIf="form.get('searchroute').at(index).get('departure')" [datepickerOptions]="INDRA_departureDatepickerOptions(this.form.get('searchroute').at(index).get('arrival'))" [disabledForm]="multicity" class="form-field col-12 col-tp-12 col-p-12"
                            [parentForm]="form.get('searchroute').at(index)" formControlName="departure" [icon]="'icons.svg#general--calendar'" [id]="'flight_status-date'" [hasError]="INDRA_showError(form.get('searchroute').at(index).get('departure'))" [label]="INDRA_getLabel(item, 'departure', index)"
                            [placeholderLabel]="INDRA_getPlaceholder(item, 'departure', index)" tabindex="0" (dateSelected)="INDRA_resetSelectedDayCount($event)">
                        </app-large-input-datepicker>
                        <span class="large-input__error" role="alert" aria-live="polite" *ngIf="INDRA_showError( form.get('searchroute').at(index).get('departure') )">{{ 'modals.errorMessage.fieldRequired' | ibeadmin | async }}</span>
                    </div>
                    <div class="form-field no-margin-adjustment col-6 col-tp-6 col-p-12" *ngIf="tripType != oneWay">
                        <app-large-input-datepicker [datepickerOptions]="INDRA_arrivalDatepickerOptions( form.get('searchroute').at(index).get('departure').value )" [disabledForm]="multicity" class="form-field col-12 col-tp-12 col-p-12" *ngIf="form.get('searchroute').at(index).get('arrival')"
                            [parentForm]="form.get('searchroute').at(index)" formControlName="arrival" [icon]="'icons.svg#general--calendar'" [id]="'flight_status-date'" [hasError]="INDRA_showError(form.get('searchroute').at(index).get('arrival'))" [label]="INDRA_getLabel(item, 'arrival', index)"
                            [placeholderLabel]="INDRA_getPlaceholder(item, 'arrival', index)" tabindex="0" (dateSelected)="INDRA_resetSelectedDayCount($event)">
                        </app-large-input-datepicker>
                        <span class="large-input__error" role="alert" aria-live="polite" *ngIf="INDRA_showError( form.get('searchroute').at(index).get('arrival') )">{{ 'modals.errorMessage.fieldRequired' | ibeadmin | async }}</span>
                    </div>
                </div>
            </ng-container>

            <ng-container formArrayName="stopover">
                <label class="label">{{ 'modals.label.whereStopover' | ibeadmin | async }} </label>
                <label class="label--description" *ngIf="enable10DaysStopover">{{ 'modals.label.youCanAddUpto10Days' | ibeadmin | async }}</label>

                <div class="stopover-country__wrapper" *ngFor="let item of stopovers | async; let index = index" [formGroupName]="index">
                    <div class="form-field--row grid no-padding" *ngIf="!enable10DaysStopover">
                        <div class="form-field no-margin col-6 col-tp-6 col-p-6">
                            <app-checkbox-input class="form-field col-6 col-tp-6 col-p-6" label="{{ item.country }}" [formControlName]="'active'" (change)="INDRA_handleCountry(form.get('stopover').at(index))" id="{{ item.country }}" [parentForm]="form.get('stopover').at(index)"
                                tabindex="0">
                            </app-checkbox-input>
                        </div>
                    </div>

                    <ng-container *ngIf="!enable10DaysStopover">
                        <ng-container *ngIf="form.get('stopover').at(index).get('active').value">
                            <div class="form-field--row grid no-padding stopover-country__fields">
                                <div class="form-field col-4 col-tp-4 col-p-12">

                                    <app-select-input (change)="INDRA_changeCity($event, item, index)" [required]="true" [hasError]="INDRA_showError(form.get('stopover').at(index).get('city'))" [id]="'city-' + index" [placeholder]="'modals.label.chooseCity' | ibeadmin | async" [label]="'modals.label.whichCity' | ibeadmin | async"
                                        [inputOptions]="item.options_city" [value]="INDRA_getCity(form.get('stopover').at(index).get('city').value)" tabindex="0">
                                    </app-select-input>
                                    <span class="large-input__error" role="alert" aria-live="polite" *ngIf="INDRA_showError( form.get('stopover').at(index).get('city') )">{{ 'modals.errorMessage.fieldRequired' | ibeadmin | async }}</span>

                                </div>

                                <div class="form-field col-4 col-tp-4 col-p-12" *ngIf="tripType != oneWay">

                                    <app-select-input (change)="INDRA_changeInput($event.target.value, form.get('stopover').at(index).get('when'))" [parentForm]="form.get('stopover').at(index)" formControlName="when" [required]="true" [hasError]="INDRA_showError(form.get('stopover').at(index).get('when'))"
                                        [id]="'when-' + index" [placeholder]="'modals.label.chooseStop' | ibeadmin | async" [label]="'modals.label.whichDirection' | ibeadmin | async" [inputOptions]="item.when" tabindex="0">
                                    </app-select-input>
                                    <div class="large-input-group-errors col-12" *ngIf="form.controls['stopover'].hasError('DuplicatesWhen')">
                                        <span class="large-input-group-error" *ngIf="form.controls['stopover'].hasError('DuplicatesWhen')">{{ 'modals.errorMessage.isinvalid' | ibeadmin | async }}</span>
                                    </div>
                                    <span class="large-input__error" role="alert" aria-live="polite" *ngIf="INDRA_showError( form.get('stopover').at(index).get('when') )">{{ 'modals.errorMessage.fieldRequired' | ibeadmin | async }}</span>

                                </div>

                                <div class="form-field col-4 col-tp-4 col-p-12">
                                    <label class="label">{{ 'modals.label.howManyNights' | ibeadmin | async }}</label>

                                    <app-segmented-control-radio classes="segmented-control--rounded" *ngIf="INDRA_showNumberOfNights()" [value]="form.get('stopover').at(index).get('days').value" (selected)="INDRA_changeInput($event, form.get('stopover').at(index).get('days'))" [options]="INDRA_getNights()"
                                        tabindex="0">
                                    </app-segmented-control-radio>
                                    <span class="large-input__error" role="alert" aria-live="polite" *ngIf="INDRA_showError( form.get('stopover').at(index).get('days') )">{{ 'modals.errorMessage.fieldRequired' | ibeadmin | async }}
									</span>
                                </div>
                            </div>

                        </ng-container>
                    </ng-container>

                    <ng-container *ngIf="enable10DaysStopover">
                        <div class="form-field--row grid no-padding stopover-country__fields">
                            <div class="form-field col-4 col-tp-4 col-p-12">

                                <app-select-input (change)="INDRA_changeCity($event, item, index)" [required]="true" [hasError]="INDRA_showError(form.get('stopover').at(index).get('city'))" [id]="'city-' + index" [placeholder]="'modals.label.chooseCity' | ibeadmin | async" [label]="'modals.label.whichCity' | ibeadmin | async"
                                    [inputOptions]="item.options_city" [value]="INDRA_getCity(form.get('stopover').at(index).get('city').value)" tabindex="0">
                                </app-select-input>
                                <span class="large-input__error" role="alert" aria-live="polite" *ngIf="INDRA_showError( form.get('stopover').at(index).get('city') )">{{ 'modals.errorMessage.fieldRequired' | ibeadmin | async }}</span>

                            </div>

                            <div class="form-field col-4 col-tp-4 col-p-12" *ngIf="tripType != oneWay">

                                <app-select-input (change)="INDRA_changeInput($event.target.value, form.get('stopover').at(index).get('when'))" [parentForm]="form.get('stopover').at(index)" formControlName="when" [required]="true" [hasError]="INDRA_showError(form.get('stopover').at(index).get('when'))"
                                    [id]="'when-' + index" [placeholder]="'modals.label.chooseStop' | ibeadmin | async" [label]="'modals.label.whichDirection' | ibeadmin | async" [inputOptions]="item.when" tabindex="0">
                                </app-select-input>
                                <div class="large-input-group-errors col-12" *ngIf="form.controls['stopover'].hasError('DuplicatesWhen')">
                                    <span class="large-input-group-error" *ngIf="form.controls['stopover'].hasError('DuplicatesWhen')">{{ 'modals.errorMessage.isinvalid' | ibeadmin | async }}</span>
                                </div>
                                <span class="large-input__error" role="alert" aria-live="polite" *ngIf="INDRA_showError( form.get('stopover').at(index).get('when') )">{{ 'modals.errorMessage.fieldRequired' | ibeadmin | async }}</span>

                            </div>

                            <div class="form-field col-4 col-tp-4 col-p-12">
                                <label class="label">{{ 'modals.label.howManyNights' | ibeadmin | async }}</label>

                                <div class="stopover-days-counter">
                                    <app-counter-input *ngIf="INDRA_showNumberOfNights()" formControlName="days" [min]="stopoverDaysMin" [max]="INDRA_getNights().length" [label]="" [description]="" [layoutFormat]="'stopovers'" [setIncrementToDisable]="setIncrementToDisable" [setDecrementToDisable]="true"
                                        (valueIncrement)="INDRA_handleIncrement($event)">
                                    </app-counter-input>

                                    <!-- <app-segmented-control-radio classes="segmented-control--rounded" *ngIf="INDRA_showNumberOfNights()" [value]="form.get('stopover').at(index).get('days').value" (selected)="INDRA_changeInput($event, form.get('stopover').at(index).get('days'))" [options]="INDRA_getNights()"
                                        tabindex="0">
                                    </app-segmented-control-radio> -->
                                </div>
                                <span class="large-input__error" role="alert" aria-live="polite" *ngIf="INDRA_showError( form.get('stopover').at(index).get('days') )">{{ 'modals.errorMessage.fieldRequired' | ibeadmin | async }}
									</span>
                            </div>
                        </div>
                    </ng-container>
                </div>

            </ng-container>

            <span class="large-input__error" role="alert" aria-live="polite" *ngIf="triedToSubmit && form.controls['stopover'].hasError('notSelected')">{{ 'modals.label.chooseOneCity' | ibeadmin | async }}</span>

            <button *ngIf="INDRA_showConfirmButton()" class="button full-width top-gap" (click)="INDRA_handleClose($event)">
				{{ 'modals.label.confirmStopover' | ibeadmin | async }}
			</button>

        </form>
    </ng-template>

</div>
